// What the page and the server agree on for browser error reports (D-043):
// environment-neutral constants, usable by the server layout and the browser.

/** Where the page posts its errors; browsers post CSP violation reports here too. */
export const CLIENT_REPORT_ENDPOINT = "/api/client-errors";

/** <meta> names of the root layout: the release that rendered the page and the page request's correlation id. */
export const RELEASE_META = "iron-release";
export const REQUEST_ID_META = "iron-request-id";

export type BrowserErrorReport = {
  kind: "error" | "unhandledrejection" | "boundary";
  type?: string;
  message?: string;
  source?: string;
  line?: number;
  column?: number;
  stack?: string;
  /** Next.js's digest of an error rendered on the server. */
  digest?: string;
};
